import { Box, IconButton, Modal } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { DpFanQuickCard, type DpFanQuickCardProps } from '@/components/blocks/DpFanQuickCard';
import {
	closeButtonSX,
	dialogContainerSX,
	modalRootSX,
	modalSX,
} from '@/components/blocks/DpFanQuickAdaptiveDialog/styles';
import { useLockBodyScroll } from '@/utils/lockBodyScroll';
import { useDismissibleDialog } from '@/utils/dismissibleDialog';

export const DpFanQuickAdaptiveDialog: React.FC<DpFanQuickCardProps> = (props) => {
	const { open, closeDialog } = useDismissibleDialog({
		storageKey: 'DpFanQuickAdaptiveDialog',
		hiddenSeconds: 86400,
	});

	useLockBodyScroll(open);

	return (
		<Modal
			slotProps={{
				root: {
					sx: modalRootSX,
				} as any,
			}}
			sx={modalSX}
			open={open}
			onClose={closeDialog}
		>
			<Box sx={dialogContainerSX}>
				<IconButton color="inherit" onClick={() => closeDialog()} sx={closeButtonSX}>
					<ClearIcon color="inherit" fontSize="inherit" />
				</IconButton>

				<DpFanQuickCard {...props} onClick={closeDialog} />
			</Box>
		</Modal>
	);
};
